import Axios from "axios";
import {
  removeAccessToken,
  storeAccessToken,
} from "../helper/manageAccessToken";
import { Cookies } from "react-cookie";
import { API_REFRESH_TOKEN } from "../config/api";
import { jwtDecode } from "jwt-decode";

export const Client = async (params) => {
  const cookies = new Cookies();
  const token = cookies.get("accessToken");
  const {
    path,
    method,
    type,
    data,
    queryParams,
    noRefreshToken,
    contentType = "application/json",
  } = params;

  const baseURL =
    process.env.REACT_APP_APP_ENV === "dev"
      ? process.env.REACT_APP_DEV_BASE_URL
      : process.env.REACT_APP_APP_ENV === "staging"
      ? process.env.REACT_APP_STAGING_BASE_URL
      : process.env.REACT_APP_PRODUCTION_BASE_URL;

  const headers = {
    ...(token && {
      Authorization: `Bearer ${token}`,
      From: "WEB-APP",
    }),
    "Content-Type": contentType,
    Accept: "application/json",
  };

  let url = type === "full-path" ? path : `${baseURL}api/v1/${path}`;

  const axiosConfig = {
    method: method,
    url: url,
    timeout: 20000,
    headers: headers,
    params: queryParams,
    responseType: "json",
  };

  if (method.toUpperCase() !== "GET") {
    axiosConfig.data =
      contentType === "multipart/form-data" ? data : JSON.stringify(data);
  }

  try {
    const response = await Axios(axiosConfig);

    if (!noRefreshToken && token) {
      const decoded = jwtDecode(token);
      const newDate = new Date(0);
      const dateOfExp = new Date(newDate.setUTCSeconds(decoded.exp)).getTime();
      newDate.setUTCSeconds(decoded.exp);

      const current = new Date().getTime();
      const getMins = parseInt((dateOfExp - current) / (1000 * 60));

      if (getMins < 19) {
        const {
          data: {
            data: { access_token },
          },
        } = await Axios({
          url: `${baseURL}api/v1/${API_REFRESH_TOKEN}`,
          timeout: 20000,
          headers: headers,

          responseType: "json",

          method: "POST",
        });

        if (access_token) {
          storeAccessToken(access_token);
        }
      }
    }

    return response;
  } catch (error) {
    // error?.response?.status === 403 ||
    if (
      error.response.data.message === "Authorization Token not found" ||
      error.response.data.message === "Token is Expired" ||
      error.response.data.message === "Token is Invalid"
    ) {
      removeAccessToken();
      // window.location = `/?message=${error.response.data.message}`;
      window.location = `/signin`;
    } else {
      throw error;
    }
  }
};
